import { downloadBlob, LocalizationService } from '@abp/ng.core';
import { ToasterService } from '@abp/ng.theme.shared';
import { Component, Injector, OnInit } from '@angular/core';
import { take } from 'rxjs/operators';
import { NotificationType } from 'src/core/decorators/notification/notification-type.decorator';
import { NotificationDto } from 'src/core/models/notification/notification.dto';
import { NotificationService } from 'src/core/services/notification/notification.service';
import { CAToasterHelperService } from 'src/core/services/toaster/ca-toaster-helper.service';
import { ExcelService } from 'src/core/services/excel/excel.service';

@Component({
  selector: 'ca-conversation-list-export-ready-notification',
  templateUrl: './conversation-list-export-ready-notification.component.html',
  styleUrls: ['./conversation-list-export-ready-notification.component.scss'],
  standalone: false,
})
@NotificationType(
  'ConversationListExportReadyNotification',
  ConversationListExportReadyNotificationComponent
)
export class ConversationListExportReadyNotificationComponent implements OnInit {
  data: NotificationDto;

  constructor(
    private excelService: ExcelService,
    public localizationService: LocalizationService,
    private toastr: ToasterService,
    private notificationService: NotificationService
  ) {}

  ngOnInit(): void {}

  static showNotification(
    notificationId: string,
    payload: string,
    toastr: ToasterService,
    localizationService: LocalizationService,
    toasterHelperService: CAToasterHelperService,
    notificationService: NotificationService,
    injector: Injector
  ) {
    const parsedPayload = JSON.parse(payload);
    let message = localizationService.instant(
      'Conversation::ClickHereToDownloadConversationsReport',
      ''
    );
    message = message.replace(/""\s*/g, '').replace(/\s{2,}/g, ' ');
    var toastrId = toastr.success(message);

    var toastrInstance = toasterHelperService.getToastById(toastrId);
    toastrInstance.onTap.pipe(take(1)).subscribe(() => {
      this.toasterClickedHandler(
        injector,
        notificationService,
        notificationId,
        parsedPayload.fileId,
        parsedPayload.partionCount,
        parsedPayload.filename ?? localizationService.instant('Conversation::ExcelExport.FileName'),
        localizationService
      );
    });
  }

  static toasterClickedHandler(
    injector: Injector,
    notificationService: NotificationService,
    notificationId: string,
    fileId: string,
    partionCount: number,
    fileName: string,
    localizationService: LocalizationService
  ) {
    let extension = localizationService.instant('Conversation::ExcelExport.FileNameExtension');
    for (let i = 0; i < partionCount; i++) {
      if (partionCount > 1) {
        fileName = fileName + '-' + (i + 1) + extension;
      } else {
        fileName += extension;
      }
      injector.get(ExcelService).downloadExcelReport(fileId, fileName, i);
    }
    notificationService.markAsRead(notificationId).pipe(take(1)).subscribe();
  }

  downloadFile() {
    const parsedPayload = JSON.parse(this.data.payload);
    this.downloadFileById(
      parsedPayload.fileId,
      parsedPayload.partionCount,
      parsedPayload.filename ??
        this.localizationService.instant('Conversation::ExcelExport.FileName')
    );
    this.notificationService
      .getReadStatus(this.data.id)
      .pipe(take(1))
      .subscribe(result => {
        if (!result) {
          this.notificationService.markAsRead(this.data.id).pipe(take(1)).subscribe();
        }
      });
  }

  downloadFileById(fileId: string, partionCount: number, fileName: string) {
    let extension = this.localizationService.instant('Conversation::ExcelExport.FileNameExtension');
    for (let i = 0; i < partionCount; i++) {
      if (partionCount > 1) {
        fileName = fileName + '-' + (i + 1) + extension;
      } else {
        fileName += extension;
      }
      this.excelService
        .getExcelReport(fileId, fileName, i)
        .pipe(take(1))
        .subscribe({
          next: result => {
            if (result.size > 0) {
              downloadBlob(result, fileName);
            }
          },
          error: () => {
            this.toastr.error('Conversation::DownloadFileError');
          },
        });
    }
  }

  getMessage(payload, localizationService) {
    const parsedPayload = JSON.parse(payload);
    let filename =
      parsedPayload.filename ?? localizationService.instant('Conversation::ExcelExport.FileName');
    let message = localizationService.instant(
      'Conversation::ClickHereToDownloadConversationsReport'
    );
    message = message.replace('{0}', filename);
    return message;
  }
}
